import React from "react";
function IconRaiting1() {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#029468" }),
        React.createElement("circle", { cx: "12", cy: "12", r: "12", stroke: "#B2DFCE" }),
        React.createElement("path", { d: "M12.8467 17.5H11.2334V11.0674C11.2334 10.8532 11.2357 10.639 11.2402 10.4248C11.2448 10.2106 11.2493 10.001 11.2539 9.7959C11.263 9.59082 11.2744 9.39486 11.2881 9.20801C11.1924 9.31283 11.0739 9.42676 10.9326 9.5498C10.7959 9.67285 10.6501 9.80046 10.4951 9.93262L9.34668 10.8486L8.54004 9.83008L11.5068 7.50586H12.8467V17.5Z", fill: "white" })));
}
export default IconRaiting1;
